import components from './componentsDictionary';

const DefaultProps = components.reduce((prev, curr) => {
	// let props = typeof curr.componentProps === 'function'?curr.componentProps():curr.componentProps
	return Object.assign(prev, { [curr.componentName]: curr.componentProps });
}, {});

export default DefaultProps;
